import { FIELD_TYPE } from '@/constants'


import getLandlordPropMgr  from './helper/landlordPropMgr'

export default [
  {
    label: 'Shelter Verification',   
    type: FIELD_TYPE.HEADING
  },  
  {
    type: FIELD_TYPE.HEADING,
    vHtmlLabel() {
      return `<strong>Rental Company</strong>`
    },
    showLabel: true,
    showInReview: true
  }, 
  {
    apiKey: `shelter.rentalCompany.name`,
    label: 'Name',
    placeHolder: 'Enter name',
    type: FIELD_TYPE.NAME,
    maxLength: 100,
    required: true
  },
  {
    apiKey: `shelter.rentalCompany.phoneNumber`,
    label: 'Phone number',
    placeHolder: 'Enter phone number',
    required: true,
    maxLength: 100
  },
  {
    apiKey: `shelter.rentalCompany.address`,
    label: 'Address',
    placeHolder: 'Enter address',
    maxLength: 100,
    required: true    
  },
  {
    apiKey: `shelter.rentalCompany.fax`,
    label: 'Fax',
    placeHolder: 'Enter fax',
    maxLength: 100
  },
    
  getLandlordPropMgr('shelter.landlordPropMgr.landlordPropMgrDetails'),
]